import type { Event } from "../../reducers/apiTypes";
import { EventImage } from "../common/EventImage";
import { EventTag } from "../common/EventTag";
import {
    categoryColor,
    categoryLabel,
    formatEventWhenShort,
} from "../../utils/eventDisplay";

type Props = {
    event: Event;
};

export function EventCard({ event }: Props) {
    const color = categoryColor(event.event_type);

    return (
        <div className="w-[260px] overflow-hidden rounded-2xl bg-white shadow-[var(--overlay-shadow)]">
            <EventImage
                event={event}
                className="aspect-[4/3] w-full rounded-none"
                emojiClassName="text-[60vw] leading-none"
            />
            <div className="flex flex-col gap-2 p-3">
                <h3 className="text-sm font-bold leading-snug text-foreground">
                    {event.name}
                </h3>
                <p className="text-xs text-muted">
                    {formatEventWhenShort(event)}
                </p>
                <div className="flex flex-wrap gap-1">
                    <EventTag label={categoryLabel(event.event_type)} color={color} />
                    <EventTag label="Free" variant="free" />
                </div>
            </div>
        </div>
    );
}
